<span class="opacity-75 fw-500 text-start">Track the individual level of engagement from each recipient of your campaign</span>


<trustifi-table-c *ngIf="!getSummaryInProcess"
	class="trustifi-table short-action-column mt-2" style="flex: 1 0; z-index: 5;"
	[list]="recipientsEventsTable.recipients"
	[headers]="recipientsEventsTable.headers"
	[cellsPrototype]="recipientsEventsTable.cells"
	[filterData]="filterData"
	(searchFunction)="searchRecipient($event)"
	[cellActions]="{
		enable: recipientsEventsTable.showActions,
		selectItemActionCb:	selectRecipientAction,
		initActionsFunction: showRecipientSummaryActions,
	}"
	[bulkActions]="{
		enable: recipientsEventsTable.showActions,
		selectBulkActionCb:	selectRecipientBulkAction,
		initBulkActionsFunction: showRecipientBulkActions
	}"
	[options]="{
		itemsNameSingular: 'recipient',
		exportToCsvFunction: exportRecipientEventsToCsv,
		refreshFunction: getSummaryData,
		defaultSortKey: '-email',
		loadingTableFlag: getSummaryInProcess,
	}"
>

	<ng-template #customCells let-item let-cellId="cellId">
		<div *ngIf="cellId === 'emailCell'" class="flxRow gap-1">
			<i *ngIf="item.status && recipientStatusDisplay[item.status]"
			   class="far {{recipientStatusDisplay[item.status].icon}}"
			   tooltip="{{recipientStatusDisplay[item.status].tooltip}}"
			   [ngStyle]="{'color' : recipientStatusDisplay[item.status].color}"></i>
			<span [tooltip]="item.email">{{item.email}}</span>
		</div>
		<div *ngIf="cellId === 'sentCell'">
			<span *ngIf="item.sent && !item.sentFailed">
				Sent
				<span *ngIf="item.sent?.created" style="font-size: 10px;"><br/>
					{{item.sent.created | date: 'MM/dd/yyyy HH:mm'}}
				</span>
			</span>
			<span *ngIf="!item.sent && !item.sentFailed">
				Not sent
			</span>
			<span style="color: red;" *ngIf="item.sentFailed">
				Not sent
				<i class="far fa-question-circle opacity-75"
				   tooltip="{{item.sentFailed.note}}"></i>
			</span>
		</div>

		<div *ngIf="cellId === 'readCell'">
			<span *ngIf="item.read">
				Read
				<img *ngIf="item.read?.location?.ll" (click)="openLocation(item.read.location.ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACoFBMVEUAAADdSj7cSz7dSz7dSz7dSz7dSj7dSz7fTUDoRkbdSj3dSz7dSz7dSz7fQEDbSTfdSz7mTTPdSz7eSj43pWc0pmg0pmjdSz7eTD00pmndTD40pmjdSj7dSz7cTD3bTED/AADfSjzdTD7NU0PVVSuOooaQuaKYv6nI3dHW0lSz1cOXu27azGSrzNLdSz40pmhfj13cSz7cSz2fbE3bSj2kOTCDLiimOTFDrXNmvI1TtH84qGvEWUSvPDKALSezPTQ3p2qk17v8/v3////q9vBju4vRUUGaNS2dNy+X0bG74cx1w5mIy6a64cs+q3DBWkatOzKxPTNAq3H5/fu74c2jak3aSj2fOC+BLSiiODDbSj5huol5xJxYtoPk8+ux3cVgjl3ZSj3ZSj5UtICQzqxKsHmg1bmi1rr9/v2w3MQ1pWi4X0fV7ODv+PNct4Y2p2ma07SEyaNVr2TLxlTbTj5VtYHr9vD9/v7g8ejw+PTM6dk5qGxXr2Tr11H93E/HrVrG5tW/49CIy6dVrmTq11L83FHJi11asGPt2FHdz3rUVEbUVETu2FHq03TEw8GkpJJcsGP93FHq1XfDw8PCw8K9cWC9cV5dsWPv2FD178zs6+vExMSqtqqptanv2FHr6c7r6+u1fGlismLy2VHo5srs7OymsKFjs2Lz2VDAvHx3nM3w9Pru7u7FxcW/wsDWVEXWUkW+wsBks2O/vHxdicRciMV2m87v8/m1fmpls2Lz2lC+u311ms7u8/nno6+iuu69rtGH22lC8un9diMR0mc3w8PDGxsZstWH32lC8uX9wl8zr8Pjx8fG1t4Rwlszq8PdttWG0toTp7/f12VCxtIevs4lvlsz+///821Ctsoro7vfy9vpSRSY7AAAALnRSTlMALYvN5+bKiCgLnv38lQgOxQquoSXG/P42w5T64suiQAE3h+IGpaquyPFuVvzMdTvKwAAAAAFiS0dEQ2fQDWIAAAAHdElNRQfiBQ0JLhcq1/DgAAACB0lEQVQ4y23Q+VtMUQDG8cMoW/YlZcm+d28pyV4Osu9LtiGRiOw7g4pBqbgRsmXJvneI7IRCpaJV/hXnPWea7h33/eWe53w/z8ydIcRkDRpaGrm5N25CzNe0WXNFzKNFS7PeyqI417qNCWir6NaOkPYdOqr6+cniP0Q8PDsRL9W4ANwHDg0KGuaPkzfpjNvg4SNGOsAoXI8ewzcWJwvhdyGh4ygdP0GCibgOA5iEUxeAyXTK1GnTZ0gwE9ezAGbj1JWDOXPn6d5hPq4XLAwPX7QYp24cLKFL1WVWq3W5ACvkr4hYKZ8+HETSVerqqDXRawVYF6P/H9y74x3Wb4hVN26imwXYsnVbfffoQQC279i5azfdsxd9337bgXrQkwigBkcdPBQnenyCzXb4SF3v1dsBnLMftfEdOy57Yh/iAuxJ6CeSUyRI6esCUtFPnkrW0k6jn0lzAeln0c+dz9C0CwAXNSNIv4R+mdIrXGQqSqZmBFev4fuvU74bGVqWomQZwc1b6Lfv3IW4d//Bw0ePDeCJ6E+z2bPnUuTkaHrw4iV6bjZj7NVrId681QPZ36Fz8R7iw0cd+JSH/vkLk/sqRH6BE3z7jv6jrjNWWARRXOAAsv9kupWUSiFAmei/mGElv4XoB1COXsFcVig+oz/AAN4r2X+r4p9RPRBg0OCaP8xkVbV/fdH/AbDMRR6RNRSkAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTEzVDA5OjQ2OjIzKzAwOjAwGkGfCQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0xM1QwOTo0NjoyMyswMDowMGscJ7UAAAAASUVORK5CYII=" alt=""/>
				<span *ngIf="item.read?.created" style="font-size: 10px;"><br/>
					{{item.read.created | date: 'MM/dd/yyyy HH:mm'}}
				</span>
			</span>
			<span *ngIf="!item.read">Not read</span>
		</div>

		<div *ngIf="cellId === 'linkCell'">
			<span *ngIf="!item.link && !item.attachment">False</span>
			<div *ngIf="item.link" class="flex-column">
				<span *ngIf="item.link?.created">{{item.link.created | date: 'MM/dd/yyyy HH:mm'}}</span>
				<span *ngIf="item.link?.agent?.browser">{{item.link.agent.browser.name + ', ' + item.link.agent.os.name + ' '+ item.link.agent.os.version}}</span>
				<span *ngIf="item.link?.ip">{{item.link.ip}}</span>
			</div>
			<div *ngIf="item.attachment" class="flex-column">
				<span *ngIf="item.attachment?.created">{{item.attachment.created | date: 'MM/dd/yyyy HH:mm'}}</span>
				<span *ngIf="item.attachment?.agent?.browser">{{item.attachment.agent.browser.name + ', ' + item.attachment.agent.os.name + ' '+ item.attachment.agent.os.version}}</span>
				<span *ngIf="item.attachment?.ip">{{item.attachment.ip}}</span>
			</div>
		</div>

		<span *ngIf="cellId === 'acknowledgeCell'"
			  [ngStyle]="{'color': item.acknowledge ? 'green' : 'red'}">
			{{item.acknowledge ? 'True' : 'False'}}
		</span>

		<span *ngIf="cellId === 'quizResultCell'"
			  [ngClass]="item.quizResult === undefined || item.quizResult === null ? 'text-muted' : 'fw-bold'">
			<span *ngIf="!item.quizResult">Unsubmitted</span>
			<span *ngIf="item.quizResult && currentCampaign.campaigns"
				  [ngStyle]="{'color': item.status === 'Pass' ? 'var(--bs-success)' : 'var(--bs-danger)'}">
				{{item.quizResult.score + '%'}}
			</span>
			<span *ngIf="item.quizResult && !currentCampaign.campaigns && currentCampaign.material?.quiz?.config?.passing_score"
				  [ngStyle]="{'color': item.quizResult.score >= currentCampaign.material.quiz.config.passing_score ? 'var(--bs-success)' : 'var(--bs-danger)'}">
				{{item.quizResult.score + '%'}}
			</span>
			<span *ngIf="item.quizResult && !currentCampaign.campaigns && !currentCampaign.material?.quiz?.config?.passing_score"
				  [ngStyle]="{'color': item.quizResult.score > 80 ? 'var(--bs-success)' : item.quizResult.score >= 50 ? 'var(--bs-warning)' : 'var(--bs-danger)'}">
				{{item.quizResult.score + '%'}}
			</span>
		</span>

		<span *ngIf="cellId === 'phishedLoginCell'"
			  [ngStyle]="{'color': item.login ? 'red' : 'green'}">
			{{item.login ? 'True' : 'False'}}
		</span>

		<span *ngIf="cellId === 'reportedCell'"
			  [ngStyle]="{'color': item.userReported ? 'green' : 'red'}">
			{{item.userReported ? 'True' : 'False'}}
		</span>
	</ng-template>
</trustifi-table-c>
